var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tree-select',{staticStyle:{"width":"300px"},attrs:{"value":_vm.value1,"treeData":_vm.treeData,"treeCheckable":"","searchPlaceholder":"请选择"},on:{"change":_vm.changeTree}})}
var staticRenderFns = []

export { render, staticRenderFns }